module.exports = __webpack_public_path__ + "img/login_left.d2c5a33d.png";